import { useRef, useEffect } from "react";
function useDraggableRefs(SVs, position) {
  const lastPositionFromCore = useRef(position);
  const fixed = useRef(false);
  const fixLocation = useRef(false);
  lastPositionFromCore.current = position;
  fixed.current = SVs.fixed;
  fixLocation.current = !SVs.draggable || SVs.fixLocation || SVs.fixed;
  return { lastPositionFromCore, fixed, fixLocation };
}
function useJSXGraphCleanup({
  objectRef,
  destroy,
  cancelLabelPlacementRef
}) {
  useEffect(() => {
    return () => {
      cancelLabelPlacementRef?.current?.();
      if (objectRef.current !== null) {
        destroy();
      }
    };
  }, []);
}
export {
  useJSXGraphCleanup as a,
  useDraggableRefs as u
};
